(function () {
  'use strict';

  var cache = new Map();
  var cacheLifetime = 5 * 60 * 1000;
  var cacheLimit = 20;
  var timer;
  var controller;
  var requestNumber = 0;
  var modal;
  var input;
  var status;
  var suggestionsGroup;
  var suggestionsList;
  var categoriesGroup;
  var categoriesList;
  var productsGroup;
  var productGrid;
  var moreLink;
  var skeleton;
  var lastFocus;
  var suppressOpen = false;

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function preciseQuery(value) {
    var words = value.trim().replace(/[():*"\\]+/g, ' ').split(/\s+/).filter(Boolean);
    return words.map(function (word) {
      return 'title:' + word + '*';
    }).join(' AND ');
  }

  function searchUrl(value, view) {
    var params = new URLSearchParams();
    params.set('q', preciseQuery(value));
    params.set('type', 'product');
    if (view) {
      params.set('view', view);
      params.set('search_version', '2');
    }
    return '/search?' + params.toString();
  }

  function createModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.className = 'weilai-native-search';
    modal.id = 'weilai-native-search';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Product search');
    modal.innerHTML =
      '<div class="weilai-native-search__panel">' +
        '<form class="weilai-native-search__form" role="search">' +
          '<input class="weilai-native-search__input" type="search" name="q" autocomplete="off" placeholder="Product Search" aria-label="Product Search">' +
          '<button class="weilai-native-search__close" type="button" aria-label="Close search">&times;</button>' +
        '</form>' +
        '<p class="weilai-native-search__status" role="status" aria-live="polite">Type at least 2 characters to search.</p>' +
        '<div class="weilai-native-search__top">' +
          '<section class="weilai-native-search__group" data-search-suggestions hidden>' +
            '<h2 class="weilai-native-search__heading">Suggestions</h2>' +
            '<ul class="weilai-native-search__links"></ul>' +
          '</section>' +
          '<section class="weilai-native-search__group" data-search-categories hidden>' +
            '<h2 class="weilai-native-search__heading">Categories</h2>' +
            '<ul class="weilai-native-search__links"></ul>' +
          '</section>' +
        '</div>' +
        '<div class="weilai-native-search__skeleton" hidden>' +
          '<span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>' +
        '</div>' +
        '<section class="weilai-native-search__products" hidden>' +
          '<h2 class="weilai-native-search__heading">Products</h2>' +
          '<div class="weilai-native-search__grid"></div>' +
          '<a class="weilai-native-search__more" href="/search">Show more</a>' +
        '</section>' +
      '</div>';

    document.body.appendChild(modal);
    input = modal.querySelector('.weilai-native-search__input');
    status = modal.querySelector('.weilai-native-search__status');
    suggestionsGroup = modal.querySelector('[data-search-suggestions]');
    suggestionsList = suggestionsGroup.querySelector('ul');
    categoriesGroup = modal.querySelector('[data-search-categories]');
    categoriesList = categoriesGroup.querySelector('ul');
    productsGroup = modal.querySelector('.weilai-native-search__products');
    productGrid = modal.querySelector('.weilai-native-search__grid');
    moreLink = modal.querySelector('.weilai-native-search__more');
    skeleton = modal.querySelector('.weilai-native-search__skeleton');

    modal.querySelector('form').addEventListener('submit', function (event) {
      event.preventDefault();
      if (input.value.trim()) window.location.href = searchUrl(input.value.trim());
    });
    modal.querySelector('.weilai-native-search__close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    input.addEventListener('input', scheduleSearch);
    suggestionsList.addEventListener('click', function (event) {
      var link = event.target.closest('[data-search-term]');
      if (!link) return;
      event.preventDefault();
      input.value = link.getAttribute('data-search-term');
      scheduleSearch();
    });
  }

  function openModal(value) {
    createModal();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('weilai-search-open');
    document.body.classList.add('weilai-search-open');
    input.value = value || '';
    window.setTimeout(function () {
      input.focus();
      if (input.value.length) input.setSelectionRange(input.value.length, input.value.length);
    }, 0);
    if (input.value.trim().length >= 2) scheduleSearch();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    window.clearTimeout(timer);
    if (controller) controller.abort();
    modal.hidden = true;
    document.documentElement.classList.remove('weilai-search-open');
    document.body.classList.remove('weilai-search-open');
    suppressOpen = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    window.setTimeout(function () { suppressOpen = false; }, 0);
  }

  function clearResults(message) {
    suggestionsGroup.hidden = true;
    categoriesGroup.hidden = true;
    productsGroup.hidden = true;
    skeleton.hidden = true;
    status.textContent = message || '';
  }

  function scheduleSearch() {
    window.clearTimeout(timer);
    var query = input.value.trim();
    if (query.length < 2) {
      if (controller) controller.abort();
      clearResults(query ? 'Type one more character to search.' : 'Type at least 2 characters to search.');
      return;
    }
    timer = window.setTimeout(function () { loadResults(query); }, 220);
  }

  function getCached(query) {
    var entry = cache.get(query.toLowerCase());
    if (!entry || Date.now() - entry.time > cacheLifetime) return null;
    return entry.data;
  }

  function setCached(query, data) {
    if (cache.size >= cacheLimit) cache.delete(cache.keys().next().value);
    cache.set(query.toLowerCase(), { time: Date.now(), data: data });
  }

  function loadResults(query) {
    var cached = getCached(query);
    if (cached) {
      render(query, cached);
      return;
    }

    if (controller) controller.abort();
    controller = new AbortController();
    var currentRequest = ++requestNumber;
    status.textContent = 'Searching...';
    skeleton.hidden = false;
    suggestionsGroup.hidden = true;
    categoriesGroup.hidden = true;
    productsGroup.hidden = true;

    var predictiveParams = new URLSearchParams();
    predictiveParams.set('q', query);
    predictiveParams.set('resources[type]', 'query,collection');
    predictiveParams.set('resources[limit]', '5');
    predictiveParams.set('resources[limit_scope]', 'each');

    Promise.all([
      fetch('/search/suggest.json?' + predictiveParams.toString(), {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      }),
      fetch(searchUrl(query, 'weilai'), {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product search failed');
        return response.json();
      })
    ]).then(function (responses) {
      if (currentRequest !== requestNumber) return;
      var predictive = responses[0].resources && responses[0].resources.results || {};
      var data = {
        suggestions: predictive.queries || [],
        categories: predictive.collections || [],
        products: responses[1].products || [],
        count: responses[1].count || 0
      };
      setCached(query, data);
      render(query, data);
    }).catch(function (error) {
      if (error.name === 'AbortError') return;
      clearResults('Search is temporarily unavailable. Press Enter to view all results.');
    });
  }

  function renderLinks(list, group, items, isSuggestion) {
    list.innerHTML = items.map(function (item) {
      var label = isSuggestion ? item.text : item.title;
      var attributes = isSuggestion
        ? 'href="' + escapeHtml(item.url || '#') + '" data-search-term="' + escapeHtml(label) + '"'
        : 'href="' + escapeHtml(item.url || '#') + '"';
      return '<li><a class="weilai-native-search__link" ' + attributes + '>' + escapeHtml(label) + '</a></li>';
    }).join('');
    group.hidden = !items.length;
  }

  function render(query, data) {
    skeleton.hidden = true;
    status.textContent = data.products.length || data.suggestions.length || data.categories.length
      ? ''
      : 'No results found for “' + query + '”.';
    renderLinks(suggestionsList, suggestionsGroup, data.suggestions.slice(0, 5), true);
    renderLinks(categoriesList, categoriesGroup, data.categories.slice(0, 5), false);

    productGrid.innerHTML = data.products.map(function (product) {
      var image = product.image
        ? '<img class="weilai-native-search__image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.image_alt) + '" loading="lazy" decoding="async">'
        : '';
      return '<a class="weilai-native-search__card" href="' + escapeHtml(product.url) + '">' +
        '<span class="weilai-native-search__image-wrap">' + image + '</span>' +
        '<span class="weilai-native-search__card-title">' + escapeHtml(product.title) + '</span>' +
        '<span class="weilai-native-search__price">' + escapeHtml(product.price) + '</span>' +
      '</a>';
    }).join('');
    productsGroup.hidden = !data.products.length;
    moreLink.href = searchUrl(query);
    moreLink.textContent = data.count > data.products.length ? 'Show more (' + data.count + ')' : 'Show more';
  }

  document.addEventListener('click', function (event) {
    var desktopTrigger = event.target.closest('#shopify-section-header_4 .frm_search_ac .js_iput_search');
    if (desktopTrigger && (!modal || modal.hidden)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(desktopTrigger.value);
      return;
    }
    var mobileTrigger = event.target.closest('.icon_search[data-id="#nt_search_canvas"]');
    if (mobileTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal('');
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (suppressOpen) return;
    if (!event.target.matches('#shopify-section-header_4 .frm_search_ac .js_iput_search')) return;
    openModal(event.target.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
})();
